<template>
    <div id="GeKlassen">
        <h1>Klassen</h1>
    </div>
</template>